import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { ContentsTitle, narrowPanelWidth } from '../../featurestore/models';
import { RequestPermission } from '../RequestPermission/RequestPermission';
import {
  IRequestPermissionPanelClassNames,
  IRequestPermissionPanelStyles,
  requestPermissionPanelStylesDefault,
} from './RequestPermissionPanel.styles';

const getBreadcrumbItems = (name: string, isProject: boolean): IBreadcrumbItem[] => {
  const title = isProject ? ContentsTitle.projectAccess : ContentsTitle.featureSetAccess;
  return [
    { text: title, key: title },
    {
      text: name,
      key: name,
      isCurrentItem: true,
    },
  ];
};

interface IRequestPermissionPanelProps {
  projectId?: string;
  featureSetId?: string;
  name?: string;
  show: boolean;
  onDismiss: (ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined, updated?: boolean) => void;
}

export const RequestPermissionPanel = ({
  name = '',
  projectId = '',
  featureSetId = '',
  show,
  onDismiss,
}: IRequestPermissionPanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: narrowPanelWidth,
    isOpen,
    onDismiss: () => onDismiss(),
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.requestAccess,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(name, !!projectId),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IRequestPermissionPanelStyles, IRequestPermissionPanelClassNames>(
    'RequestPermissionPanel',
    requestPermissionPanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <RequestPermission
          projectId={projectId}
          featureSetId={featureSetId}
          onSave={() => onDismiss(undefined, true)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
